<template>
  <div class="layout-container transition-linear" v-loading="GET_LAYOUT_LOADING || GET_LAN_LAYOUT_LOADING">
    <div class="aside transition-linear">
      <!-- 用户详情 -->
      <div class="asideItem">
        <div class="user" v-if="GET_TOKEN">
          <div class="userLeft">
            <img :src="userData.userAvatar" />
            <span>{{ userData.userName }}</span>
          </div>
          <div class="userRight" @click="handleLogout"></div>
        </div>
        <div class="lan-login" v-else>
          <div class="lan-login-btn" @click="loginHandle">
            {{ $t("LoginNow") }}
          </div>
          <div class="lan-login-text">{{ $t("view_only_lan") }}</div>
        </div>
      </div>
      <!-- 局域打印机 -->
      <div class="asideItem">
        <div class="LanPrinter" @click="lanOpen = !lanOpen">
          <div class="left font-family-95">{{ $t("LANPrinter") }}</div>
          <div class="right">
            <img v-show="!lanOpen" src="../../assets/imgs/closeIcon.png" />
            <img v-show="lanOpen" src="../../assets/imgs/openIcon.png" />
          </div>
        </div>
        <template v-if="lanOpen">
          <div class="printerItem" :class="[
              $route.name == 'workbench' &&
                GET_LAN_MQTT?.uuid == item.uuid &&
                'selectItem',
            ]" v-for="(item, index) of GET_LAN_PRINTER_LIST" :key="index" @click="handleLanPrinter(item)">
            <div class="left">{{ item.name }}</div>
            <!--  v-show="item.status" -->
            <div class="right" :class="
                item.status == 'busy'
                  ? 'busy'
                  : item.status == 'free'
                  ? 'free'
                  : 'offline'
              ">
              {{
              item.status == "busy"
              ? "Busy"
              : item.status == "free"
              ? "Free"
              : "Offline"
              }}
            </div>
          </div>
        </template>
      </div>
      <!-- 广局域打印机 -->
      <div class="asideItem">
        <div class="CloudPrinter" @click="cloudOpen = !cloudOpen">
          <div class="left font-family-95">{{ $t("CloudPrinter") }}</div>
          <div class="right">
            <img v-show="!cloudOpen" src="../../assets/imgs/closeIcon.png" />
            <img v-show="cloudOpen" src="../../assets/imgs/openIcon.png" />
          </div>
        </div>
        <template v-if="cloudOpen">
          <div class="printerItem" :class="[
              $route.name == 'workbench' &&
                currentPrinter == item.id &&
                'selectItem',
            ]" v-for="(item, index) of GET_CLOUD_PRINTER_LIST" :key="index" @click="handlePrinter(item)"
            v-show="index < 20">
            <div class="left">{{ item.name }}</div>
            <div class="right" :class="
                $common.formatterStatus(item.device_status, item.is_printing) ==
                'Busy'
                  ? 'busy'
                  : $common.formatterStatus(
                      item.device_status,
                      item.is_printing
                    ) == 'Free'
                  ? 'free'
                  : 'offline'
              ">
              {{
              $t(
              $common.formatterStatus(item.device_status, item.is_printing)
              )
              }}
            </div>
          </div>
        </template>
      </div>
      <!-- 打印机列表 -->
      <div class="asideItem">
        <div class="CloudPrinter" :class="[$route.name == 'printerList' && 'selectItem']" @click="viewList">
          <div class="left font-family-95">{{ $t("printer_list") }}</div>
          <div class="right">
            <img src="../../assets/imgs/closeIcon.png" />
          </div>
        </div>
      </div>
      <!-- 云空间 -->
      <div class="asideItem" v-if="GET_TOKEN">
        <div class="CloudPrinter" :class="[$route.name == 'cloudSpace' && 'selectItem']" @click="jumpCloudSpace">
          <div class="left font-family-95">{{ $t("cloud_files") }}</div>
          <div class="right">
            <img src="../../assets/imgs/closeIcon.png" />
          </div>
        </div>
      </div>
      <div class="asideItem">
        <div class="AddPrinter" @click="addPrinter">
          <div class="left">{{ $t("AddPrinter") }}</div>
          <div class="right">
            <img src="../../assets/imgs/addIcon.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="tip" v-if="
          !isOnline ||
          ($route.path == '/workbench' &&
            lan_mqtt?.haveTip &&
            lan_mqtt?.haveTip != 0)
        ">
        <template v-if="!isOnline">
          {{ $t("network_unavailable_retry") }}
        </template>
        <template v-else-if="lan_mqtt?.haveTip == 1">
          {{
          $common.replaceSeat(
          $t("retry_tip"),
          $global.lanCount - lan_mqtt.retryCount
          )
          }}
        </template>
        <template v-else-if="lan_mqtt?.haveTip == 2">
          {{ $t("disconnection_tip") }}
        </template>
        <template v-else-if="lan_mqtt?.haveTip == 3">
          {{ $t("connect_fail_tip") }}
          <span class="link" @click="retry">{{ $t("Retry") }}</span>
          <!-- <span class="nomal">{{ $t("or") }}</span
          ><span class="link">{{ $t("ViewWiki") }}</span> -->
        </template>
      </div>
      <div class="contentRoute">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <!-- <router-view :key="$route.path" /> -->
      </div>
    </div>
    <addPrinter :visible.sync="addDialog" @cnSubmit="cnSubmit"></addPrinter>
  </div>
</template>

<script>
import AddPrinter from "../components/dialog/addPrinter";
import {
  connect,
  stateCallback,
  isConnect,
  subscribe,
  set_recv,
  destroyMqtt,
  createMqtt,
  configWrite,
} from "../../api/slicer/printer.js";
import {
  getInfo,
  getTaskInfo,
  getPrinters,
  postSendOrder,
  getPrinterFileDetails,
} from "../../api/network/printer.js";
import { mapGetters, mapActions } from "vuex";
import { receiveTopic } from "@/utils/topic.js";
import { account } from "@/utils/account";
import global from "@/utils/global.js";
import { createMqttLan, setMqttLanConnct, publish } from "@/utils/lanMqtt";
import { formmatImg } from "@/utils/common.js";
import materialsAll from "@/api/materialsAll";

export default {
  name: "layout",
  components: {
    AddPrinter,
  },
  data() {
    return {
      accountClient: null,
      addDialog: false,
      avater: "",
      username: "",
      lanOpen: true,
      cloudOpen: true,
      currentPrinter: "",
      timeout: null,
      printerFileDetails: {},
    };
  },
  computed: {
    ...mapGetters([
      "GET_LAYOUT_LOADING",
      "GET_USER_INFO",
      "GET_LAN_MQTT",
      "GET_LAN_LAYOUT_LOADING",
      "GET_PRINTER_TYPE",
      "GET_TOKEN",
      "GET_HAVE_TIP",
      "GET_LAN_RETRY_COUNT",
      "GET_CUR_PRINTER",
      "GET_CLOUD_IS_SELECT_ID",
      "GET_LAN_PRINTER_LIST",
      "GET_CLOUD_PRINTER_LIST",
      "GET_CLOUD_INFO_REFRESH"
    ]),
    isOnline() {
      // 网络状态
      return this.$store.getters.GET_ISONLINE;
    },
    // 兼容头像名称不同字段
    userData() {
      let userName = null;
      let userAvatar = null;
      if (
        this.GET_USER_INFO?.casdoor_user?.avatar ||
        this.GET_USER_INFO?.casdoor_user?.display_name
      ) {
        userName = this.GET_USER_INFO.casdoor_user.display_name;
        userAvatar = this.GET_USER_INFO?.casdoor_user?.avatar
          ? this.GET_USER_INFO?.casdoor_user?.avatar
          : require("@/assets/imgs/user_default.png");
      } else {
        userName = this.GET_USER_INFO?.user_nickname;
        userAvatar = this.GET_USER_INFO?.avatar
          ? this.GET_USER_INFO.avatar
          : require("@/assets/imgs/user_default.png");
      }
      return {
        userName,
        userAvatar,
      };
    },
    lan_mqtt() {
      return (
        this.GET_LAN_PRINTER_LIST.find(
          (i) => i?.uuid === this.GET_LAN_MQTT?.uuid
        ) || {}
      );
    },
  },
  watch: {
    GET_TOKEN: async function (val) {
      if (val) {
        this.SET_LOADING_TRUE();
        await this.getPrinters().then(() => {
          this.SET_LOADING_FALSE();
        });

        await destroyMqtt(global.identity);
        // 创建mqtt
        await this.createMqttCloud();
        // 连接mqtt
        this.setMqttConnct();
      } else {
        if (
          this.$route.path !== "/workbench" &&
          this.GET_LAN_PRINTER_LIST?.length
        ) {
          // 不是工作台详情页面
          this.$router.push("/workbench");
          this.selectFirst();
        } else if (!this.GET_LAN_PRINTER_LIST?.length) {
          // 没有局域网答应机
          location.reload();
        } else {
          // 默认选择第一台
          this.selectFirst();
        }
      }
    },
    GET_LAN_MQTT: {
      handler(mqtt) {
        // 局域网设备切换重置逻辑
        if (mqtt) {
          this.$store.commit("DEL_CUR_PRINTER");
          this.$store.commit("DEL_CUR_TASK");
          this.$store.commit("SET_PRINTER_TYPE", "lan");
          let curPrinter = this.GET_CUR_PRINTER || {};
          curPrinter.deviceId = mqtt?.deviceId;
          curPrinter.img = formmatImg(mqtt?.modelName);
          curPrinter.name = mqtt?.name;
          curPrinter.model = mqtt?.modelName;
          curPrinter.ip = mqtt?.ip;
          curPrinter.version = {};
          curPrinter.version.firmware_version =
            mqtt?.version?.firmware_version || "";
          curPrinter.status = mqtt?.status;
          curPrinter.project = undefined;
          this.$store.commit("SET_CUR_PRINTER", curPrinter);
          publish(
            mqtt?.uuid,
            `anycubic/anycubicCloud/v1/web/printer/${mqtt.modeId}/${mqtt.deviceId}/info`,
            {
              type: "info",
              action: "query",
              timestamp: new Date().getTime(),
              msgid: `${this.$uuid.v1()}`,
              data: null,
            }
          );

          // 灯光查询
          publish(
            mqtt?.uuid,
            `anycubic/anycubicCloud/v1/web/printer/${mqtt.modeId}/${mqtt.deviceId}/light`,
            {
              type: "light",
              action: "query",
              timestamp: new Date().getTime(),
              msgid: `${this.$uuid.v1()}`,
              data: null,
            }
          );
          // materialsAll("getInfoMultiColorBox");
          materialsAll("peripherie");
        }
      },
    },
    currentPrinter: {
      handler(val, oldval) {
        if (this.GET_PRINTER_TYPE == "cloud") {
          this.$store.commit("DEL_CUR_PRINTER");
          this.$store.commit("DEL_CUR_TASK");
          if (val) {
            this.getPrinterInfo(val);
          }
        }
      },
    },
    "GET_CUR_PRINTER.device_status": {
      handler(val, oldval) {
        if (this.GET_PRINTER_TYPE == "cloud") {
          if (oldval == "2" && val == "1") {
            this.queryLight(this.GET_CUR_PRINTER.id);
          }
        }
      },
      deep: true,
    },
    GET_PRINTER_TYPE: {
      handler(val, oldVal) {
        if (val == "cloud" && oldVal == "lan") {
          this.$store.commit("DEL_LAN_MQTT");
        }
        if (val == "lan") {
          this.currentPrinter = "";
        }
        // if(val == 'cloud') {
        //   let LanList = JSON.parse(JSON.stringify(this.$store.getters.GET_LAN_PRINTER_LIST));
        //   LanList.forEach((item) => {
        //     item.status = ''
        //   })
        //   this.$store.commit("SET_LAN_PRINTER_LIST", LanList);
        //   this.$store.commit("DEL_LAN_MQTT");
        //   this.$store.commit("SET_HAVE_TIP", 0);
        // }
      },
    },
    GET_CLOUD_IS_SELECT_ID: {
      handler(val) {
        if (!val) return;
        this.currentPrinter = val;
        this.$store.commit("SET_CLOUD_IS_SELECT_ID", null);
      },
    },
    GET_CLOUD_INFO_REFRESH: {
      handler (val) {
        if (!val) return;
        this.getPrinterInfo(val, true)
        this.$store.commit('SET_CLOUD_INFO_REFRESH', null)
      },
    }
    // GET_LAN_PRINTER_LIST:{
    //   handler(val) {
    //    this.lan_mqtt = val.find(i =>  i.uuid === this.GET_LAN_MQTT.uuid )
    //   }
    // }
  },
  // ---
  async created () {
    const mqtt = this.lan_mqtt;
    if (mqtt && Object.keys(mqtt).length > 0) {
      this.$store.commit("DEL_CUR_PRINTER");
      this.$store.commit("DEL_CUR_TASK");
      this.$store.commit("SET_PRINTER_TYPE", "lan");
      let curPrinter = this.GET_CUR_PRINTER || {};
      curPrinter.deviceId = mqtt?.deviceId;
      curPrinter.img = formmatImg(mqtt?.modelName);
      curPrinter.name = mqtt?.name;
      curPrinter.model = mqtt?.modelName;
      curPrinter.ip = mqtt?.ip;
      curPrinter.version = {};
      curPrinter.version.firmware_version =
        mqtt?.version?.firmware_version || "";
      curPrinter.status = mqtt?.status;
      // curPrinter.project = undefined;
      this.$store.commit("SET_CUR_PRINTER", curPrinter);
    }
    if (this.GET_LAN_PRINTER_LIST.length) {
      let lanArr = this.GET_LAN_PRINTER_LIST.map((mqtt) => {
        return {
          ...mqtt,
          model: mqtt?.modelName,
          img: formmatImg(mqtt?.modelName),
          isConnect: true,
          haveTip: 0,
          retryCount: this.$global.lanCount,
        };
      });
      lanArr = lanArr.concat(lanArr);
      this.$store.commit("SET_LAN_PRINTER_LIST", lanArr);

      // 处理初始化以及刷新订阅所有打印机
      this.GET_LAN_PRINTER_LIST.forEach((mqtt) => {
        this.connectLanPrinter(mqtt);
      });
    }
    // if (this.GET_TOKEN) {
      this.SET_LOADING_TRUE();
      this.$store.commit("SET_SUBSCRIBE", true);
      await this.getPrinters().then(() => {
        this.SET_LOADING_FALSE();
        this.$store.commit("SET_SUBSCRIBE", false);
      });
    // }

    // 创建mqtt 1111
    await this.createMqttCloud();
    // 连接mqtt
    this.setMqttConnct();
  },
  beforeDestroy() {
    // 销毁mqtt
    destroyMqtt(global.identity);
  },
  methods: {
    ...mapActions(["SET_LOADING_TRUE", "SET_LOADING_FALSE"]),
    async retry() {
      let lanList = JSON.parse(JSON.stringify(this.GET_LAN_PRINTER_LIST));
      let idx = lanList.findIndex((item) => {
        return item.uuid == this.GET_LAN_MQTT.uuid;
      });
      if (idx != -1) {
        lanList[idx] = {
          ...lanList[idx],
          isConnect: true,
          haveTip: 0,
          retryCount: this.$global.lanCount,
        };
        this.$store.commit("SET_LAN_PRINTER_LIST", lanList);
      }
      await this.connectLanPrinter(this.lan_mqtt);
    },
    async connectLanPrinter(mqtt) {
      await createMqttLan(mqtt?.uuid);
      setMqttLanConnct(mqtt);

      // 防止重复点击
      this.$store.commit("SET_LAN_LAYOUT_LOADING", true);
      setTimeout(() => {
        this.$store.commit("SET_LAN_LAYOUT_LOADING", false);
      }, 1000);
    },
    createMqttCloud() {
      return createMqtt(global.identity, global.objectName, 2);
    },
    async setMqttConnct() {
      if (this.GET_TOKEN) {
        await set_recv(this.$global.objectName, receiveTopic);
        await stateCallback(this.$global.objectName, this.connectStatus);

        let isConnected = await isConnect(this.$global.objectName);

        console.log("isConnected========>成功返回true", isConnected);
        console.log("=======>this.$global.objectName", this.$global.objectName);
        if (!isConnected) {
          let connectIndex = await connect(this.$global.objectName, {
            mode: 2,
            device_type: "fdm",
          });
        } else {
          console.log(
            "connectIndex GET_CLOUD_PRINTER_LIST=======>",
            this.GET_CLOUD_PRINTER_LIST
          );
          this.GET_CLOUD_PRINTER_LIST.forEach((data) => {
            subscribe(
              this.$global.objectName,
              `anycubic/anycubicCloud/v1/+/public/${data.machine_type}/${data.key}/+/report`
            );
            // 订阅多色盒子ota升级
            subscribe(
              this.$global.objectName,
              `anycubic/anycubicCloud/v1/+/public/${data.machine_type}/${data.key}/ota/multiColorBox/+/report`
            );
          });
        }
      }
    },
    // 默认选第一台机器
    selectFirst() {
      if (this.GET_LAN_MQTT) {
        return false;
      }
      let info = this.GET_CUR_PRINTER;
      if (info && Object.keys(info).length > 0) {
        this.$store.commit("SET_PRINTER_TYPE", "cloud");
        this.currentPrinter = info.id + "";
      } else {
        if (this.GET_CLOUD_PRINTER_LIST.length > 0) {
          this.$store.commit("SET_PRINTER_TYPE", "cloud");
          this.currentPrinter = this.GET_CLOUD_PRINTER_LIST[0].id + "";
        } else {
          this.SET_LOADING_FALSE();
          this.currentPrinter = "";
          this.$store.commit("DEL_PRINTER_TYPE");

          // 判断有没有局域网打印机
          let LanList = JSON.parse(JSON.stringify(this.GET_LAN_PRINTER_LIST));
          if (LanList && LanList.length > 0) {
            this.$store.commit("SET_PRINTER_TYPE", "lan");
            this.$store.dispatch("SET_LAN_MQTT", LanList[0]);
          }
        }
      }
    },
    async connectStatus(action, code, msg) {
      console.log(
        "MQTT链接回调是否执行====================>action, code, msg",
        action,
        code,
        msg
      );
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        if (action == 500 && code == 0) {
          console.log("广域网连接事件========>成功", new Date());
          this.GET_CLOUD_PRINTER_LIST.forEach((data) => {
            subscribe(
              this.$global.objectName,
              `anycubic/anycubicCloud/v1/+/public/${data.machine_type}/${data.key}/+/report`
            );
            // 订阅多色盒子ota升级
            subscribe(
              this.$global.objectName,
              `anycubic/anycubicCloud/v1/+/public/${data.machine_type}/${data.key}/ota/multiColorBox/+/report`
            );
          });

          // postSendOrder({
          //   order_id: "1206",
          //   printer_id: this.GET_CUR_PRINTER.id
          // });
          materialsAll("peripherie");
          // postSendOrder({
          //   order_id: "1230",
          //   printer_id: this.GET_CUR_PRINTER.id
          // });

          this.$store.commit("SET_SUBSCRIBE", true);
          // 订阅
        } else if (action == 500 && code != 0) {
          this.$store.commit("SET_SUBSCRIBE", false);
          console.log("广域网连接事件========>失败", new Date());
          // 销毁mqtt
          await destroyMqtt(global.identity);
          // 创建mqtt
          await this.createMqttCloud();
          // 连接mqtt
          this.setMqttConnct();
        } else if (action == 501) {
          console.log("广域网连接断开", new Date());
          this.$store.commit("SET_SUBSCRIBE", false);
        } else if (action == 502) {
          console.log("广域网订阅事件", new Date());
          this.$store.commit("SET_SUBSCRIBE", true);
        } else if (action == 503) {
          console.log("广域网连接丢失", new Date());
          this.$store.commit("SET_SUBSCRIBE", false);
        } else if (action == 504) {
          console.log("广域网发布事件", new Date());
        }
      }, 4000);
    },
    handleLogout () {
      configWrite("TransferDownloadStatus", 0);
      configWrite("TransferUploadStatus", 0);
      account.logout();
    },
    handlePrinter (item) {
      this.$store.commit("SET_SUBSCRIBE", true);
      this.$store.commit("SET_PRINTER_TYPE", "cloud");
      console.log(this.$route);
      if (this.$route.path != "/workbench") {
        this.$router.push({
          path: "/workbench",
          query: { id: item.id, key: item.key },
        });
      } else {
        this.currentPrinter = item.id + "";
        // this.getPrinterInfo(item.id);
      }
    },
    // 查询灯光状态
    queryLight(id) {
      postSendOrder({
        order_id: "1232",
        printer_id: id,
      });
    },
    getPrinterInfo (id, isReRequest = false) {
      if (!isReRequest) {
        this.SET_LOADING_TRUE();
      }
      getInfo({ id: id })
        .then((res) => {
          if (res.code == 1) {
            // 设备在线查询灯光
            if (res.data.device_status != 2) {
              this.queryLight(id);
            }

            this.$store.dispatch("SET_CUR_PRINTER", { ...res.data });
            this.SET_LOADING_FALSE();

            // 保证列表跟info一致
            let cloudList = JSON.parse(
              JSON.stringify(this.GET_CLOUD_PRINTER_LIST)
            );
            let idx = cloudList.findIndex((item) => id == item.id);
            if (idx != -1) {
              cloudList.splice(idx, 1, { ...res.data });
              this.$store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
            }

            if (
              !!res.data.project &&
              Object.keys(res.data.project).length > 0
            ) {
              getTaskInfo({ id: res.data.project.task_id }).then((res1) => {
                this.$store.dispatch("SET_CUR_TASK", res1.data);
              });
            } else {
              this.$store.dispatch("DEL_CUR_TASK");
            }
          } else {
            this.$store.dispatch("DEL_CUR_PRINTER");
            this.$store.dispatch("DEL_CUR_TASK");
            this.SET_LOADING_FALSE();
          }
        })
        .catch(() => {
          this.SET_LOADING_FALSE();
        });
    },
    async cnSubmit(id) {
      if (id) {
        this.currentPrinter = id + "";
      }
      this.SET_LOADING_TRUE();
      await this.getPrinters().then(() => {
        this.SET_LOADING_FALSE();
      });
      this.GET_CLOUD_PRINTER_LIST.forEach((data) => {
        subscribe(
          this.$global.objectName,
          `anycubic/anycubicCloud/v1/+/public/${data.machine_type}/${data.key}/+/report`
        );
        // 订阅多色盒子ota升级
        subscribe(
          this.$global.objectName,
          `anycubic/anycubicCloud/v1/+/public/${data.machine_type}/${data.key}/ota/multiColorBox/+/report`
        );
      });
    },
    async getPrinters() {
      let res = await getPrinters({ type: "FDM" });
      if (res.code != 1) {
        this.SET_LOADING_FALSE();
        this.selectFirst();
        return false;
      }
      let vuexCloudList = [];
      const promises = res?.data?.map(async (item) => {
        return await getInfo({ id: item.id });
      });
      return Promise.all(promises)
        .then((results) => {
          results.forEach((res) => {
            if (res.code == 1) {
              let data = res?.data;
              vuexCloudList.push(data);
            }
          });
          console.log("所有请求已完成:", results);
          vuexCloudList = this.$common.px(vuexCloudList);
          this.$store.commit("SET_CLOUD_PRINTER_LIST", vuexCloudList);
          this.selectFirst();
        })
        .catch((error) => {
          this.SET_LOADING_FALSE();
          // 如果任何一个请求失败，会进入这里的代码块
          console.error("请求失败:", error);
        });
    },
    addPrinter() {
      this.addDialog = true;
    },
    openLan() {
      this.lanOpen = true;
    },
    closeLan() {
      this.lanOpen = false;
    },
    openCloud() {
      this.cloudOpen = true;
    },
    closeCloud() {
      this.cloudOpen = false;
    },
    viewList() {
      this.$router.push({
        name: "printerList",
      });
    },
    //  跳转云空间
    jumpCloudSpace() {
      this.$router.push({
        name: "cloudSpace",
      });
    },
    handleLanPrinter(item) {
      this.$store.dispatch("SET_LAN_MQTT", item);
      if (this.$route.path != "/workbench") {
        this.$router.push("/workbench");
      }
    },
    loginHandle() {
      account.login();
    },
    async modelSkip(taskid) {
      const { id } = this.$store?.getters?.GET_CUR_PRINTER;
      const res = await getPrinterFileDetails({
        printer_id: id,
        taskid,
      });
      console.log("modelSkip", res);
      const { code, data } = res;
      if (code !== 1) return;
      this.$store.commit("SET_PRINTER_FILE_DETAILS", data);
    },
  },
};
</script>
<style scoped lang="scss">
.font-family-95 {
  font-family: AlibabaPuHuiTi-3-85-Bold;
}

.layout-container {
  width: 100%;
  height: 100%;
  display: flex;
}

.aside {
  font-family: AlibabaPuHuiTi-3-65-Medium;
  flex-shrink: 0;
  border-bottom: 1px solid var(--workbench-base-color);
  width: 302px;
  background: var(--dialog-background-color);
  border-radius: 0px 0px 0px 0px;

  overflow-y: scroll;

  // .asideOne {
  //   padding: 0 34px 0 16px;
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  //   width: 100%;
  //   height: 46px;
  //   background: #3986ff;
  //   box-sizing: border-box;
  //   .oneLeft {
  //     display: flex;
  //     align-items: center;
  //     .tab {
  //       width: 20px;
  //       height: 20px;
  //       margin-right: 10px;
  //     }
  //     .arrow {
  //       width: 14px;
  //       height: 14px;
  //       margin-right: 4px;
  //     }
  //     span {
  //       font-weight: normal;
  //       font-size: 14px;
  //       color: #ffffff;
  //     }
  //   }
  //   .oneRight {
  //     cursor: pointer;
  //     img {
  //       width: 11px;
  //       height: 11px;
  //       margin-right: 4px;
  //     }
  //   }
  // }
  .asideItem {
    width: 100%;
    border-radius: 0px 0px 0px 0px;
    border-bottom: 1px solid var(--workbench-left-division-line);
    box-sizing: border-box;

    .user {
      width: 100%;
      background: var(--dialog-background-color);
      border-radius: 0px 0px 0px 0px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 13px 16px 13px 24px;

      .userLeft {
        display: flex;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
          border-radius: 50%;
        }

        span {
          font-weight: normal;
          font-size: 14px;
          color: var(--first-text-color);
          line-height: 16px;
          margin-left: 8px;
        }
      }

      .userRight {
        width: 38px;
        height: 36px;
        background: url(@/assets/imgs/log-out.png) no-repeat;
        cursor: pointer;
      }

      .userRight:hover {
        background-image: url(@/assets/imgs/log-out-hover.png);
      }
    }

    .lan-login {
      padding: 20px 24px 15px;

      .lan-login-btn {
        width: 100%;
        line-height: 30px;
        height: 30px;
        background: var(--VI-color);
        border-radius: 6px 6px 6px 6px;
        color: #fff;
        text-align: center;
        cursor: pointer;
      }

      .lan-login-text {
        margin-top: 8px;
        width: 100%;
        height: 17px;
        font-size: 12px;
        color: #8c8c8c;
        line-height: 14px;
      }
    }

    .LanPrinter {
      width: 100%;
      background: var(--dialog-background-color);
      border-radius: 0px 0px 0px 0px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 13px 16px 13px 24px;
      cursor: pointer;

      .left {
        font-size: 14px;
        color: var(--first-text-color);
        line-height: 16px;
      }

      .right {
        img {
          width: 14px;
          height: 14px;
        }
      }
    }

    .CloudPrinter {
      width: 100%;
      background: var(--dialog-background-color);
      border-radius: 0px 0px 0px 0px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 13px 16px 13px 24px;
      cursor: pointer;

      .left {
        font-size: 14px;
        color: var(--first-text-color);
        line-height: 16px;
      }

      .right {
        img {
          width: 14px;
          height: 14px;
        }
      }
    }

    .selectItem {
      background: rgba(67, 141, 255, 0.24) !important;
    }

    .printerItem {
      width: 100%;
      background: var(--dialog-background-color);
      border-radius: 0px 0px 0px 0px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 13px 16px 13px 32px;
      cursor: pointer;
      border: 1px solid transparent;

      .left {
        font-weight: normal;
        font-size: 12px;
        color: var(--first-text-color);
        line-height: 14px;
        margin-right: 3px;
        word-break: break-all;
      }

      .right {
      }

      &:hover {
        border-color: #438dff;
      }
    }

    .AddPrinter {
      width: 100%;
      background: var(--dialog-background-color);
      border-radius: 0px 0px 0px 0px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 13px 16px 13px 24px;
      cursor: pointer;

      .left {
        font-size: 14px;
        color: #438dff;
        line-height: 16px;
      }

      .right {
        img {
          width: 16px;
          height: 16px;
        }
      }
    }
  }
}

.main {
  padding: 10px 10px 10px 10px;
  flex-grow: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  background-color: var(--workbench-base-color);

  .tip {
    padding: 10px 16px;
    height: 40px;
    background: rgba(255, 103, 0, 0.06);
    margin-bottom: 5px;
    text-overflow: hidden;
    white-space: nowrap;
    overflow: ellipsis;
    display: flex;
    align-items: center;
    font-weight: normal;
    font-size: 13px;
    line-height: 18px;
    color: #ff6700;

    .link {
      color: #438dff;
      cursor: pointer;
      margin: 0 8px;
    }

    .nomal {
      font-weight: normal;
      color: var(--first-text-color);
    }
  }

  .contentRoute {
    flex-grow: 1;
  }
}

@media screen and (max-width: 1499px) {
  .layout-container {
    .aside {
      width: 200px;
    }
  }
}
</style>
